const CONTENTO_ACCESSIBILITIES = {
    AUDIO_DESCRIBED: 'AudioDescribed',
    SIGN_INTERPRETED: 'SignInterpreted',
    DEFAULT: 'Default',
};

export default CONTENTO_ACCESSIBILITIES;
